import "./App.scss";
import Routers, { router } from "./components/Router";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { logout, loginSignupSelector } from "./components/login-signup/LoginSignupSlice";

function App() {
  const dispatch = useAppDispatch();
  const { authenticated } = useAppSelector(loginSignupSelector);

  // Sync auth state across browser tabs
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // Check if persist:root was removed or modified
      if (event.key === "persist:root") {
        if (!event.newValue) {
          // localStorage was cleared - user logged out in another tab
          dispatch(logout());
          router.navigate("/", { replace: true });
        } else {
          // Check if authenticated changed to false
          try {
            const newState = JSON.parse(event.newValue);
            const loginSignup = JSON.parse(newState.loginSignup || "{}");
            if (authenticated && !loginSignup.authenticated) {
              // User logged out in another tab
              dispatch(logout());
              router.navigate("/", { replace: true });
            } else if (!authenticated && loginSignup.authenticated) {
              // User logged in another tab
              window.location.reload();
            }
          } catch {
            // JSON parse error - ignore
          }
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch, authenticated]);

  return <Routers />;
}

export default App;

